import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import emailjs from '@emailjs/browser';
import {motion} from 'framer-motion'
import '../Component/css/Contact.css';


function Contact() {
    const navigate = useNavigate()

    const form = useRef();
    const sendEmail = (e) => {
      e.preventDefault();
  
      emailjs.sendForm('service_camgn03', 'template_bzoc58g', form.current, 'V_CvsAz-thDBD-zNd')
        .then((result) => {
            console.log(result.text);
        }, (error) => {
            console.log(error.text);
        });
        form.current.reset()
    };
  

    return (
        <div className='contact'>       
            <section className="contact-section ">
                <div className="container">
                    <div className="cont-section-title sec-padding ">
                        <h2>Let's connect.</h2>
                    </div>
                </div>                  
                <div className="contact-form">
                    <div className="contact-info">
                        <div className="contact-info-item">
                            <p>Checkout my socials</p>
                            <div className="social-links">
                                <motion.p whileHover={{scale:1.3, originY:1}} ><a href="https://twitter.com/tunde__dev" target="_blank"  rel="noopener noreferrer" style={{ textDecoration: 'none' }} ><i   className="fab fa-twitter"></i></a></motion.p>

                                <motion.p whileHover={{scale:1.3, originY:1}} ><a href="https://www.instagram.com/tunde.dev/" target="_blank"  rel="noopener noreferrer" style={{ textDecoration: 'none' }} ><i  className="fab fa-instagram"></i></a></motion.p>

                                <motion.p whileHover={{scale:1.3, originY:1}} ><a href="https://www.linkedin.com/in/adekoya-tunde/" target="_blank"  rel="noopener noreferrer" style={{ textDecoration: 'none' }} ><i  className="fab fa-linkedin-in"></i></a></motion.p>

                                <motion.p whileHover={{scale:1.3, originY:1}} ><a href="https://medium.com/@AdekoyaTunde" target="_blank"  rel="noopener noreferrer" style={{ textDecoration: 'none' }} ><i  className="fab fa-medium-m"></i></a></motion.p>

                                <motion.p whileHover={{scale:1.3, originY:1}} ><a href="https://vm.tiktok.com/ZMLdNJfyJ/" target="_blank"  rel="noopener noreferrer" style={{ textDecoration: 'none' }} ><i  className="fab fa-tiktok"></i></a></motion.p>

                                <motion.p whileHover={{scale:1.3, originY:1}} ><a href="https://www.behance.net/AdekoyaTunde" target="_blank"  rel="noopener noreferrer" style={{ textDecoration: 'none' }} ><i  className="fab fa-behance"></i></a></motion.p>

                                <motion.p whileHover={{scale:1.3, originY:1}} ><a href="https://github.com/TundeAdekoya" target="_blank"  rel="noopener noreferrer" style={{ textDecoration: 'none' }} ><i  className="fab fa-github"></i></a></motion.p>

                                <motion.p whileHover={{scale:1.3, originY:1}} ><a href="https://www.youtube.com/channel/UC4nHV13gukA1X2ziTADRK0g" target="_blank"  rel="noopener noreferrer" style={{ textDecoration: 'none' }} ><i className="fab fa-youtube"></i></a></motion.p>
                            </div>
                        </div>
                    </div> 
                    <div className='top'>
                        <p>Looking forward to hearing from you at <a href="https://mail.google.com/mail/u/0/#inbox?compose=CllgCJlKGDFfFSVFMxwHpxRBBsXrbLFwCqxmDmfhWXNwFMDbSspktJQqgCmZRzhpJjmxszwQZkg" target="_blank"  rel="noopener noreferrer " style={{ textDecoration: 'none', color: 'var(--black-light)' }} ><b>adekoyatunde101@gmail.com</b></a></p>
                    </div>
                        <form ref={form} onSubmit={sendEmail}>
                            <input type="text" required name="name" placeholder='Your name..'/>
                            <input type="email" required name="user_email" placeholder='Your email..'/>
                            <textarea name="message" required placeholder= "What's on your mind.."/>                                   
                            <input type="submit" value="Get In Touch" />
                            {/* <div className='middle' >
                                <motion.input type="submit" className="conctactbtn" value="Get In Touch" whileHover={{ boxShadow: '0px 0px 0px' ,scale:1.1, originY:1, color:'var(--black)', fontWeight:'500'}}  transition={{type: 'tween'}} />
                            </div> */}
                        </form>
                    </div>                       
            </section>            
{/* End work Detail */}
            <div onClick={() => navigate('/')} className="go_to1">
                                        <p>Return to Home</p> 
                                        <div className="icon">
                                            <i class="fas fa-angle-right"></i>
                                            <i class="fas fa-angle-right"></i>
                                        </div>
                            </div>
        </div>
    ) 
}

export default Contact
